// extracted by mini-css-extract-plugin
module.exports = {"content":"Error_content__p8bxv","message":"Error_message__1aANQ"};